import {createTheme, responsiveFontSizes} from "@mui/material";
import {THEME_CONFIG} from "../config";

const {
  gradients,
  borders,
  borderRadius,
  shadows,
  primary,
  secondary,
  accent,
  background,
  mode,
  text,
  buttonText
} = THEME_CONFIG

const pleshDark = responsiveFontSizes(createTheme({
    typography: {
      fontFamily: ['OpenSansVar']
    },
    components:{
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background: background,
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "fixed",
                },
            },
        },
        MuiDialog:{
            styleOverrides:{
                paper:{
                    background: background,
                }
            }
        },
        MuiTextField:{
            styleOverrides:{
                root:{
                    '& fieldset':{
                        borderWidth:'3px !important',
                        borderRadius:borderRadius.textField
                    }
                }
            }
        },
        MuiButton:{
            variants: [
                {
                    props: {variant: 'default'},
                    style:{
                        minHeight: '50px',
                        height: 'fit-content',
                        width:'100%',
                        fontSize: '20px',
                        background: 'linear-gradient(90deg, '+gradients.default[0]+' 0%, '+gradients.default[1]+')',
                        border:borders.default,
                        color: buttonText.default,
                        borderRadius: borderRadius.default,
                        borderWidth: '3px',
                        boxShadow: shadows.default,
                        '&.Mui-disabled': {
                            color: 'rgba(0, 0, 0, 0.25)',
                        },
                        '&:active': {
                            color: buttonText.default,
                            background: 'linear-gradient(90deg, '+gradients.default[0]+' 0%, '+gradients.default[1]+')',
                        },
                        '&:hover': {
                            color: buttonText.default,
                            background: 'linear-gradient(90deg, '+gradients.default[0]+' 0%, '+gradients.default[1]+')',
                        }
                    }
                },
                {
                    props: {variant: 'home-question'},
                    style:{
                        background: 'linear-gradient(90deg, '+gradients.home_question[0]+' 0%, '+gradients.home_question[1]+')',
                        border:borders.home_question,
                        color: buttonText.home_question,
                        borderRadius: borderRadius.default,
                        width: '100%',
                        lineHeight:1,
                        minHeight: '60px',
                        height: 'fit-content',
                        boxShadow: shadows.home_question,
                        borderBottom:'8px solid #80CDD3',
                        fontSize: '1.5rem',
                    }
                },
            ]
        },
    },
    palette: {
        mode: mode,
        primary: {
            main: primary,
        },
        secondary: {
            main: secondary,
        },
        accent: {
            main: accent,
        },
        text: {
            primary: text,
        },
        background:{
            default:background
        }
    },
}));

export default pleshDark
